import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import GuestFields from "./GuestFields";

// Guests of the booking card; they can no longer change on the payment step.
function GuestDropdown({ step, limits, showErrors = false, focusToken = 0 }) {
  const { t } = useTranslation();
  const { persons } = useSelector((state) => state.search);

  return (
    <div className={`formGroup dropdownWrap mb0 w-full`}>
      <div className='numberOfGuest'>
        <h2 className='guest-heading'>{t("number_of_guests")}</h2>
        <GuestFields
          persons={persons}
          limits={limits}
          locked={step > 1}
          showErrors={showErrors}
          focusToken={focusToken}
          quantityClassName='custom-input'
        />
      </div>
    </div>
  );
}

export default GuestDropdown;
